<svg
  version="1.1"
  id="Layer_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 36 36"
  style="enable-background: new 0 0 36 36"
  xml:space="preserve"
>
  <ng-container *ngIf="white">
    <style type="text/css">
      svg .white {
        fill: #fff;
      }
    </style>
  </ng-container>

  <ng-container *ngIf="icon === 'activity'">
    <style type="text/css">
      .icon-activity {
        fill: #ff7300;
      }
    </style>
    <path
      class="icon-activity"
      [ngClass]="{ white: white }"
      d="M34.5,21.7c-0.7,0-1.5,0-2.2,0c-1.1,0-2.2,0-3.2,0c-0.1-0.2-0.1-0.3-0.2-0.5c-0.4-1.3-0.8-2.6-1.2-3.9
c-0.5-1.6-1-3.1-1.5-4.7c-0.4-1.3-0.8-2.7-1.3-4c-0.2-0.7-0.4-1.3-0.6-2c0,0,0,0,0,0c-0.2-0.6-0.8-1.2-1.5-1.1
c-0.7,0-1.3,0.4-1.5,1.1c-0.2,0.7-0.4,1.5-0.6,2.2c-0.5,1.7-0.9,3.5-1.4,5.2c-0.6,2.1-1.1,4.2-1.7,6.3c-0.3,1.2-0.7,2.5-1,3.7
c0-0.1,0-0.1-0.1-0.2c-0.5-1.3-1-2.6-1.6-3.9c-0.4-1.1-0.9-2.3-1.4-3.4c-0.2-0.6-0.4-1.1-0.7-1.7c0,0,0,0,0,0
c-0.1-0.2-0.2-0.5-0.4-0.7c-0.2-0.2-0.5-0.4-0.9-0.4c-0.6-0.1-1.3,0.2-1.5,0.7c-0.4,0.9-0.9,1.8-1.3,2.7c-0.7,1.4-1.4,2.8-2.1,4.2
c0,0.1-0.1,0.1-0.1,0.2c-1.5,0-3,0-4.5,0c-0.3,0-0.5,0-0.8,0c-0.8,0-1.6,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5c1.8,0,3.6,0,5.4,0
c0.3,0,0.5,0,0.8,0c0.5,0,1.1-0.3,1.3-0.8c0.4-0.9,0.9-1.8,1.3-2.7c0.4-0.8,0.7-1.5,1.1-2.3c0.2,0.4,0.3,0.8,0.5,1.3
c0.5,1.3,1,2.6,1.6,3.9c0.4,1.1,0.9,2.3,1.4,3.4c0.2,0.6,0.4,1.1,0.7,1.7c0,0,0,0,0,0c0.1,0.3,0.3,0.6,0.5,0.8
c0.3,0.2,0.6,0.3,0.9,0.3c0.7,0,1.3-0.4,1.5-1.1c0.2-0.7,0.4-1.5,0.6-2.2c0.5-1.7,0.9-3.5,1.4-5.2c0.6-2.1,1.1-4.2,1.7-6.3
c0.3-1,0.5-2,0.8-3.1c0,0.1,0.1,0.3,0.1,0.4c0.5,1.6,1,3.1,1.5,4.7c0.4,1.3,0.8,2.7,1.3,4c0.2,0.7,0.4,1.3,0.6,2c0,0,0,0,0,0
c0.2,0.6,0.8,1.1,1.5,1.1c0.7,0,1.5,0,2.2,0c1.2,0,2.4,0,3.5,0c0.3,0,0.5,0,0.8,0c0.8,0,1.6-0.7,1.5-1.5
C36,22.4,35.3,21.7,34.5,21.7z"
    ></path>
  </ng-container>

  <ng-container *ngIf="icon === 'dump'">
    <style type="text/css">
      .icon-dumpstation {
        fill: #56235d;
      }
    </style>
    <path
      class="icon-dumpstation"
      [ngClass]="{ white: white }"
      d="M36,14.5c0-0.7-0.6-1.3-1.3-1.3H23.9c-0.7,0-1.3,0.6-1.3,1.3s0.6,1.3,1.3,1.3h1.3c0.6,0,1,0.4,1,1v9
c0,0.6-0.4,1-1,1H11c-0.6,0-1-0.4-1-1v-9c0-0.6,0.4-1,1-1h1.1c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3H1.3c-0.7,0-1.3,0.6-1.3,1.3
l0,0c0,0.7,0.6,1.3,1.3,1.3h5.1c0.6,0,1,0.4,1,1v11.6c0,0.6,0.4,1,1,1h19.5c0.6,0,1-0.4,1-1V16.8c0-0.6,0.4-1,1-1h4.8
C35.4,15.8,36,15.3,36,14.5L36,14.5z"
    ></path>
    <path
      class="icon-dumpstation"
      [ngClass]="{ white: white }"
      d="M12.8,18.4c-0.5,0.5-0.4,1.4,0.1,1.8l4.4,3.8c0.4,0.3,0.9,0.3,1.3,0l4.4-3.8c0.5-0.5,0.6-1.3,0.1-1.8l0,0
c-0.5-0.5-1.3-0.6-1.8-0.1l-2.1,1.8V6.7c0-0.7-0.6-1.3-1.3-1.3l0,0c-0.7,0-1.3,0.6-1.3,1.3V20l-2.1-1.8
C14.1,17.8,13.3,17.9,12.8,18.4L12.8,18.4z"
    ></path>
  </ng-container>

  <ng-container *ngIf="icon === 'restArea'">
    <style type="text/css">
      .icon-reststop {
        fill: #bc6c25;
      }
    </style>
    <path
      class="icon-reststop"
      [ngClass]="{ white: white }"
      d="M34.5,16.8h-8L23.6,9H30c0.8,0,1.5-0.7,1.5-1.5l0,0C31.5,6.7,30.8,6,30,6H6.2C5.4,6,4.7,6.7,4.7,7.5l0,0
C4.7,8.3,5.4,9,6.2,9h6.2l-2.9,7.8h-8c-0.8,0-1.5,0.7-1.5,1.5l0,0c0,0.8,0.7,1.5,1.5,1.5h6.8L4.5,30h3.8l3.8-10.1h11.7L27.7,30h3.8
l-3.8-10.1h6.8c0.8,0,1.5-0.7,1.5-1.5l0,0C36,17.5,35.3,16.8,34.5,16.8z M13.3,16.8L16.2,9h3.5l2.9,7.8H13.3z"
    ></path>
  </ng-container>

  <ng-container *ngIf="icon === 'wifi'">
    <style type="text/css">
      .icon-wifi {
        fill: #009f4f;
      }
    </style>
    <path
      class="icon-wifi"
      [ngClass]="{ white: white }"
      d="M35.2,11C30.6,6.5,24.5,4,18,4l0,0C11.5,4,5.4,6.5,0.8,11c-1.1,1-1.1,2.7,0,3.7c0.5,0.5,1.2,0.8,1.9,0.8
s1.4-0.3,1.9-0.8c3.6-3.5,8.3-5.5,13.4-5.5l0,0c5.1,0,9.9,1.9,13.4,5.5c1.1,1,2.7,1,3.8,0C36.3,13.7,36.3,12,35.2,11z"
    ></path>
    <path
      class="icon-wifi"
      [ngClass]="{ white: white }"
      d="M7.9,18c-1.1,1-1.1,2.7,0,3.7c0.5,0.5,1.2,0.8,1.9,0.8s1.4-0.3,1.9-0.8c3.5-3.4,9.1-3.4,12.6,0
c1,1,2.7,1,3.8,0c1.1-1,1.1-2.7,0-3.7C22.5,12.6,13.5,12.6,7.9,18z"
    ></path>
    <ellipse class="icon-wifi" [ngClass]="{ white: white }" cx="18" cy="27.9" rx="4.2" ry="4.1"></ellipse>
  </ng-container>

  <ng-container *ngIf="icon === 'potableWater'">
    <style type="text/css">
      .icon-water {
        fill: #00acdc;
      }
    </style>
    <g>
      <path
        class="icon-water"
        [ngClass]="{ white: white }"
        d="M28.3,16.9l-8.9-16C19.1,0.3,18.6,0,18,0c-0.3,0-0.6,0.1-0.8,0.2c-0.2,0.1-0.4,0.3-0.5,0.5l0,0l-9,16.1
c-1.7,2.9-2.1,6.2-1.3,9.6c0.8,3.2,2.8,6.1,5.5,7.8c1.8,1.1,4,1.7,6.1,1.7c6.6,0,12-5.7,12-12.6C30,21.1,29.4,18.8,28.3,16.9z
M18,32.6c-1.4,0-2.9-0.4-4.4-1.2c-1.3-0.8-2.4-1.9-3.3-3.4c-1.6-2.9-1.5-6.5,0.1-9.4L18,5.1l7.5,13.5c1.6,3,1.6,6.6,0,9.4
C24,30.8,21.1,32.6,18,32.6z"
      ></path>
      <path
        class="icon-water"
        [ngClass]="{ white: white }"
        d="M22.9,20.7c-1,0-1.6,0.9-1.6,1.7c0,3-1.4,5.1-4.2,5.1c-1,0-1.6,0.9-1.6,1.7c0,0.8,0.7,1.7,1.6,1.7
c4.7,0,7.5-3.5,7.5-8.5C24.5,21.5,23.9,20.7,22.9,20.7z"
      ></path>
    </g>
  </ng-container>

  <ng-container *ngIf="icon === 'propane'">
    <style type="text/css">
      .icon-lpg {
        fill: #d00000;
      }
    </style>
    <g>
      <path
        class="icon-lpg"
        [ngClass]="{ white: white }"
        d="M25.9,10.1c-1.5-3-4-6-7.9-9.8C17.8,0.1,17.6,0,17.2,0c0,0,0,0,0,0c-0.5,0-0.9,0.4-1,1
c-0.8,5.3-2.7,7.3-4.5,9.3C9.9,12.4,8,14.5,8,19.2c0,2.2,0.8,4.2,2.4,5.9c1.3,1.4,3.1,2.5,5.1,3.2c0.1,0,0.2,0.1,0.4,0.1
c0.5,0,0.9-0.3,1.1-0.8c0.1-0.4,0-0.8-0.2-1.2c-1.4-1.8-2-3.3-2-4.6c0-0.7,0.3-1.4,0.6-2.1c0.6,0.3,1.1,0.4,1.5,0.4
c0.2,0,0.4,0,0.6-0.1c0.9-0.3,1.6-1,2-2.2c0.2-0.5,0.4-1.1,0.5-1.8c1.3,1.8,1.9,3.5,1.9,5c0,2.5-1.6,4.3-2.5,5.3
c-0.4,0.5-0.5,1.2,0,1.7c0.2,0.2,0.5,0.4,0.8,0.4c0.1,0,0.1,0,0.2,0c3.8-0.6,7.7-4.2,7.7-9.2C28,15.7,27.4,12.9,25.9,10.1z
M23.4,24.3c0.4-1,0.6-2.1,0.7-3.2c0-2.9-1.4-5.9-4.2-8.9c-0.2-0.2-0.5-0.4-0.8-0.4c-0.3,0-0.6,0.1-0.8,0.3c-0.3,0.3-0.4,0.7-0.3,1
c0.1,0.5,0,2.5-0.5,3.7c-0.2,0.5-0.5,0.8-0.6,0.8c0,0-0.1,0-0.1,0c-0.2,0-0.5-0.1-1.2-0.7c-0.2-0.2-0.4-0.3-0.7-0.3
c-0.3,0-0.7,0.2-0.9,0.4c-0.1,0.1-0.1,0.2-0.1,0.2l-0.2,0.4c-0.5,1.1-1.1,2.3-1.1,3.8c0,0.8,0.1,1.6,0.4,2.5
c-0.4-0.3-0.7-0.5-0.9-0.8c-1.2-1.2-1.7-2.6-1.7-4.1c0-3.8,1.2-5.1,2.9-7l0.2-0.2c1.6-1.9,3.5-4.2,4.6-8.5c3,3,4.9,5.5,6.1,7.8
c1.2,2.4,1.8,4.8,1.8,7.9C25.8,21.1,24.9,23,23.4,24.3z"
      ></path>
      <g>
        <path
          class="icon-lpg"
          [ngClass]="{ white: white }"
          d="M24.8,33.6l-13.6,0c-0.7,0-1.2,0.6-1.2,1.3c0,0.6,0.6,1.2,1.2,1.2l13.6,0c0.7,0,1.2-0.5,1.2-1.2
c0-0.3-0.1-0.6-0.3-0.9C25.4,33.7,25.1,33.6,24.8,33.6z"
        ></path>
        <path
          class="icon-lpg"
          [ngClass]="{ white: white }"
          d="M22.3,32.3c0.7,0,1.2-0.5,1.2-1.2c0-0.7-0.5-1.2-1.2-1.2l-8.7,0c-0.7,0-1.2,0.6-1.2,1.3
c0,0.6,0.6,1.2,1.2,1.2L22.3,32.3z"
        ></path>
      </g>
    </g>
  </ng-container>

  <ng-container *ngIf="icon === 'hide'">
    <style type="text/css">
      .icon-hide {
        fill: #454545;
      }
    </style>
    <g>
      <path
        class="icon-hide"
        [ngClass]="{ white: white }"
        d="M35.8,17.1L35.8,17.1c-0.5-0.9-2.1-3.5-4.9-6l3.5-2.4c0.6-0.4,0.8-1.2,0.4-1.8c-0.4-0.6-1.2-0.8-1.8-0.4
l-4.3,2.9C26,7.6,22.5,6.2,18.1,6.2c-11.1,0-16.8,9-17.8,10.8c-0.3,0.6-0.3,1.3,0,1.9c0.5,0.9,2.2,3.6,5.1,6l-3.6,2.4
c-0.6,0.4-0.8,1.2-0.4,1.8c0.2,0.4,0.7,0.6,1.1,0.6c0.2,0,0.5-0.1,0.7-0.2l4.4-2.9c2.7,1.8,6.2,3.2,10.6,3.2
c11.2,0,16.7-9,17.7-10.9C36.1,18.3,36.1,17.7,35.8,17.1z M2.7,18C4,15.9,8.9,8.8,18.1,8.8c3.3,0,6,0.9,8.2,2.2l-2.6,1.7
c-1.4-1.5-3.4-2.5-5.6-2.5c-4.3,0-7.7,3.5-7.7,7.7c0,1.1,0.2,2.2,0.7,3.2l-3.5,2.3C4.9,21.4,3.3,19.1,2.7,18z M23.2,18
c0,2.8-2.3,5.2-5.2,5.2c-1.3,0-2.5-0.5-3.4-1.3l8.3-5.5C23.1,16.9,23.2,17.4,23.2,18z M13.2,19.7c-0.2-0.5-0.3-1.1-0.3-1.7
c0-2.8,2.3-5.2,5.2-5.2c1.3,0,2.5,0.5,3.4,1.3L13.2,19.7z M18.1,27.2c-3.3,0-6-0.9-8.2-2.2l2.6-1.7c1.4,1.5,3.4,2.4,5.6,2.4
c4.3,0,7.7-3.5,7.7-7.7c0-1.1-0.2-2.2-0.7-3.1l3.5-2.3c2.5,2,4.1,4.4,4.7,5.4C32.1,20.1,27.2,27.2,18.1,27.2z"
      ></path>
    </g>
  </ng-container>
</svg>
